import React, { useState } from 'react'
import CustomAlert from '../../../../components/shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import { MDBCollapse, MDBBtn } from 'mdb-react-ui-kit'
import ChangeRequestStore from './ChangeRequest.store'
import ContentHtml from '../../../../components/content/ContentHtml/ContentHtml.component'
import { UIInput, UISelect, UITextarea } from '../../../../components/forms/form-fields'

import './ChangeRequestForm.component.scss'

export default observer(() => {
  const [msg, setMsg] = useState(null),
    {
      RequestingUser,
      Division,
      CommLevelsList,
      uplineName,
      commLevelName,
      requestNotes,
      submit,
      isSubmitting,
      isLoading,
    } = ChangeRequestStore,
    commLevelOpts = (CommLevelsList || []).map(C => ({
      value: C.get('com_name'),
      text: C.get('com_name'),
      checked: commLevelName === C.get('com_name'),
    }))

  const onSubmit = async () => {
    try {
      await submit()
      setMsg(true)
    } catch (ex) {
      setMsg(`${ex}`)
    }
  }

  return (
    <div id='ChangeRequestFormComponent'>
      <div>
        <ContentHtml contentSlug='agent-change-request-instructions' />
      </div>
      <br />
      <table className='requestor-table'>
        <thead>
          <tr>
            <th colSpan='2'>Who is requesting the change?</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Requesting Agent:</td>
            <td>
              {RequestingUser?.get('u_nickname') || RequestingUser?.get('u_fname')} {RequestingUser?.get('u_lname')}
            </td>
          </tr>
          <tr>
            <td>Agent Email:</td>
            <td>{RequestingUser?.get('u_email')}</td>
          </tr>
          <tr>
            <td>Division:</td>
            <td>{Division?.get('d_name')}</td>
          </tr>
        </tbody>
      </table>
      <br />
      <form>
        <br />
        <UIInput
          label='Enter New Upline Name'
          onChange={evt => (ChangeRequestStore.uplineName = evt.target.value)}
          value={uplineName}
        />
        <br />
        <UISelect
          label='Select Commission Level'
          onChange={evt => (ChangeRequestStore.commLevelName = evt.target.value)}
          options={commLevelOpts}
          value={commLevelName}
        />
        <br />

        <UITextarea
          label='Notes & Comments'
          onChange={evt => (ChangeRequestStore.requestNotes = evt.target.value)}
          value={requestNotes}
        />

        <br />
        <MDBCollapse open={!!msg}>
          <CustomAlert color={msg === true ? 'success' : 'danger'} style={{ textAlign: 'center' }}>
            <div className='text-center'>
              {msg === true ? 'Great. Your request has been submited to Broker Support.' : msg}
            </div>
          </CustomAlert>
          <br />
        </MDBCollapse>
        <MDBBtn type='button' color='default' sm block disabled={isSubmitting || isLoading} onClick={() => onSubmit()}>
          {isSubmitting ? 'Submitting ...' : 'Submit Change Request'}
        </MDBBtn>
      </form>
    </div>
  )
})
